"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageToName = void 0;
var Pages_1 = require("@/rendering/common/Pages");
exports.pageToName = function (page) {
    var pageName = Pages_1.Pages[page];
    return pageName;
};
